import { gql, useMutation } from '@apollo/client';

import type { UpdateDependentMutation, UpdateDependentMutationVariables } from './__generated__/useUpdateDependent.gql';

const UPDATE_DEPENDENT = gql`
  mutation UpdateDependent($input: UpdateDependantInput!) {
    updateDependant(input: $input) {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
    }
  }
`;

/**
 * Updates an existing `Dependant` row. Apollo's normalized cache merges the
 * returned fields by `Dependant:<id>` so any consumer of the same dependent
 * picks up the new values without a manual refetch. Used by
 * `DependentEntryStep` in edit mode.
 */
export const useUpdateDependent = () => {
  return useMutation<UpdateDependentMutation, UpdateDependentMutationVariables>(UPDATE_DEPENDENT);
};
